import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import { StoreProvider, useStore } from './shared/contexts/StoreContext';
import { CartProvider } from './shared/contexts/CartContext';
import { ToastProvider } from './shared/contexts/ToastContext';
import { StatusProvider } from './shared/contexts/StatusContext';
import { ComandaSessionProvider } from './shared/contexts/ComandaSessionContext';
import { GlobalStyles } from './shared/components/GlobalStyles';
import { ErrorPage } from './shared/components/ErrorPage/ErrorPage';
import { AppRoutes } from './routes';
import { useVersionCheck } from './shared/hooks/useVersionCheck';

const AppContent: React.FC = () => {
    const { store, error } = useStore();

    if (error) {
        return <ErrorPage message="Verifique o endereço e tente novamente" />;
    }

    if (!store) {
        return null;
    }

    const theme = {
        primary: store.primaryColor || store.headerColor,
        secondary: store.secondaryColor,
        background: store.backgroundColor,
    };

    return (
        <ThemeProvider theme={theme}>
            <GlobalStyles theme={theme} />
            <StatusProvider storeId={store.id}>
                <ComandaSessionProvider>
                    <CartProvider>
                        <ToastProvider>
                            <AppRoutes />
                        </ToastProvider>
                    </CartProvider>
                </ComandaSessionProvider>
            </StatusProvider>
        </ThemeProvider>
    );
};

function VersionWatcher() {
    useVersionCheck();
    return null;
}

export const App: React.FC = () => {
    return (
        <BrowserRouter>
            <VersionWatcher />
            <StoreProvider>
                <AppContent />
            </StoreProvider>
        </BrowserRouter>
    );
};
